import { isWeb, getPlatform } from '../src/utils/platformUtils'
import { LEARNING_STORE_NAMES } from '../src/db/constants'
import DatabaseSingleton from '../database-sqlite/DatabaseSingleton'

// Exportar LEARNING_STORE_NAMES para uso en otros archivos de database
export { LEARNING_STORE_NAMES }

// Utilidad para parseo seguro de JSON o aceptar estructuras ya materializadas
const safeParseJSON = (val, def = []) => {
    if (val == null) return def
    if (Array.isArray(val)) return val
    if (typeof val === 'object') return val
    if (typeof val === 'string') {
        try {
            return JSON.parse(val)
        } catch {
            return def
        }
    }
    return def
}

// ✅ LIMPIEZA COMPLETADA: buildLocalWrappedDb, getWrappedDB y openDatabase eliminados
// Todos los métodos ahora usan getRealDatabase() del DatabaseSingleton

// ✅ Importar getRealDatabase desde DatabaseSingleton (única fuente de verdad)
import { getRealDatabase } from '../database-sqlite/DatabaseSingleton'

class learningServices {
    constructor() {
        // Métodos usan getRealDatabase() directamente
    }

    /**
     * @description funcion para trareme un curso con sus contenidos en base al id
     * @param {*} courseId
     * @returns
     */
    get_course_by_id = (courseId) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                try {
                    const txCourse = db.transaction([LEARNING_STORE_NAMES.COURSES], 'readonly')
                    const storeCourse = txCourse.objectStore(LEARNING_STORE_NAMES.COURSES)
                    const reqCourse = storeCourse.get(courseId)

                    reqCourse.onsuccess = (e) => {
                        const course = e.target.result
                        if (!course) {
                            resolve(null)
                            return
                        }

                        const modulIds = safeParseJSON(course.moduls, [])
                        const evaluationIds = safeParseJSON(course.evaluations, [])

                        const txContents = db.transaction([LEARNING_STORE_NAMES.CONTENTS], 'readonly')
                        const storeContents = txContents.objectStore(LEARNING_STORE_NAMES.CONTENTS)
                        const reqAllContents = storeContents.getAll()

                        reqAllContents.onsuccess = (ce) => {
                            const allContents = ce.target.result || []
                            const resolvedModuls = modulIds
                                .map((m) => {
                                    const id = m && typeof m === 'object' ? m._id : m
                                    return allContents.find((c) => c && c._id === id) || (typeof m === 'object' ? m : null)
                                })
                                .filter(Boolean)

                            const txEvals = db.transaction([LEARNING_STORE_NAMES.EVALUATIONS], 'readonly')
                            const storeEvals = txEvals.objectStore(LEARNING_STORE_NAMES.EVALUATIONS)
                            const reqAllEvals = storeEvals.getAll()

                            reqAllEvals.onsuccess = (ee) => {
                                const allEvals = ee.target.result || []
                                const resolvedEvaluations = evaluationIds
                                    .map((ev) => {
                                        const id = ev && typeof ev === 'object' ? ev._id : ev
                                        const found = allEvals.find((x) => x && x._id === id) || (typeof ev === 'object' ? ev : null)
                                        return found ? transformEvaluation(found) : null
                                    })
                                    .filter(Boolean)

                                resolve({
                                    ...course,
                                    moduls: resolvedModuls,
                                    evaluations: resolvedEvaluations,
                                })
                            }
                            reqAllEvals.onerror = (err) => reject(err?.target?.error || err)
                        }
                        reqAllContents.onerror = (err) => reject(err?.target?.error || err)
                    }
                    reqCourse.onerror = (err) => reject(err?.target?.error || err)
                } catch (err) {
                    reject(err)
                }
            } else {
                (async () => {
                    try {
                        const realDb = await getRealDatabase()
                        const result = await realDb.getFirstAsync(
                            `SELECT * FROM ${LEARNING_STORE_NAMES.COURSES} WHERE _id = ?;`,
                            [courseId]
                        )
                        const course = result
                        
                        if (!course) {
                            resolve(null)
                            return
                        }

                        let modulIds = course.moduls
                        try {
                            if (typeof modulIds === 'string' && modulIds.startsWith('"')) {
                                modulIds = JSON.parse(modulIds)
                            }
                            if (typeof modulIds === 'string') {
                                modulIds = JSON.parse(modulIds)
                            }
                        } catch (e) {
                            modulIds = []
                        }
                        if (!Array.isArray(modulIds)) modulIds = []

                        let modulesPromises = []
                        for (const modulID of modulIds) {
                            let modul = await this.get_content_by_id(modulID)
                            if (!modul) continue
                            modulesPromises.push(modul)
                        }

                        let evaluationsIds = course.evaluations
                        try {
                            if (typeof evaluationsIds === 'string' && evaluationsIds.startsWith('"')) {
                                evaluationsIds = JSON.parse(evaluationsIds)
                            }
                            if (typeof evaluationsIds === 'string') {
                                evaluationsIds = JSON.parse(evaluationsIds)
                            }
                        } catch (e) {
                            evaluationsIds = []
                        }
                        if (!Array.isArray(evaluationsIds)) evaluationsIds = []
                        
                        let evaluationsPromises = []
                        for (const evaluationID of evaluationsIds) {
                            let ev = await this.get_evaluation_by_id(evaluationID)
                            if (!ev) continue
                            evaluationsPromises.push(ev)
                        }
                        
                        console.log('INFO FINAl ===>', modulesPromises, '===>', evaluationsPromises)
                        
                        const [modules, evaluations] = await Promise.all([
                            Promise.all(modulesPromises),
                            Promise.all(evaluationsPromises)
                        ])
                        
                        const courseWithModulesAndEvaluations = {
                            ...course,
                            moduls: modules,
                            evaluations: evaluations,
                        }
                        resolve(courseWithModulesAndEvaluations)
                    } catch (error) {
                        console.error('get_course_by_id error:', error)
                        reject(error)
                    }
                })()
            }
        })
    }

    /**
     * @description funcion para traerme un contenido en base al id
     * @param {*} contentId
     * @returns
     */
    get_content_by_id = (contentId) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([LEARNING_STORE_NAMES.CONTENTS], 'readonly')
                const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.CONTENTS)

                const request = objectStore.get(contentId)

                request.onsuccess = (event) => {
                    const content = event.target.result
                    if (!content) {
                        resolve(null)
                        return
                    }
                    const modified_content = {
                        ...content,
                        status: typeof content.status === 'string' ? parseInt(content.status) : content.status,
                        evaluations: safeParseJSON(content.evaluations, []),
                        media_slides: safeParseJSON(content.media_slides, []),
                    }
                    resolve(modified_content)
                }
                request.onerror = (event) => reject(event.target.error)
            } else {
                (async () => {
                    try {
                        const realDb = await getRealDatabase()
                        const content = await realDb.getFirstAsync(
                            `SELECT * FROM ${LEARNING_STORE_NAMES.CONTENTS} WHERE _id = ?`,
                            [contentId]
                        )
                        
                        console.log('Llego acá antes de romper==>', contentId)
                        
                        if (content) {
                            const modified_content = {
                                ...content,
                                status: typeof content.status === 'string' ? parseInt(content.status) : content.status,
                                evaluations: safeParseJSON(content.evaluations, []),
                                media_slides: safeParseJSON(content.media_slides, []),
                            }
                            resolve(modified_content)
                        } else {
                            resolve(null)
                        }
                    } catch (error) {
                        console.error('get_content_by_id error:', error)
                        reject(error)
                    }
                })()
            }
        })
    }

    get_evaluation_by_id = (evaluationId) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([LEARNING_STORE_NAMES.EVALUATIONS], 'readonly')
                const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.EVALUATIONS)
                const request = objectStore.get(evaluationId)

                request.onsuccess = (event) => {
                    const evaluation = event.target.result
                    // Realiza las transformaciones necesarias
                    const modifiedEvaluation = transformEvaluation(evaluation)
                    resolve(modifiedEvaluation)
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                (async () => {
                    try {
                        const realDb = await getRealDatabase()
                        const evaluation = await realDb.getFirstAsync(
                            `SELECT * FROM ${LEARNING_STORE_NAMES.EVALUATIONS} WHERE _id = ?;`,
                            [evaluationId]
                        )
                        
                        if (evaluation) {
                            const modifiedEvaluation = transformEvaluation(evaluation)
                            resolve(modifiedEvaluation)
                        } else {
                            console.log('la evaluacion no fue encontrada ...')
                            resolve(null)
                        }
                    } catch (error) {
                        console.error('get_evaluation_by_id error:', error)
                        reject(error)
                    }
                })()
            }
        })
    }
}

export const LearningServices = new learningServices()

//* funciones
const transformEvaluation = (evaluation) => {
    if (!evaluation) return null
    return {
        ...evaluation,
        type_assessment: safeParseJSON(evaluation.type_assessment, {}),
        questions: safeParseJSON(evaluation.questions, []),
        survey: safeParseJSON(evaluation.survey, {}),
    }
}
